import { Spinner } from "@blueprintjs/core";

export default function Loader() {
  return <Spinner size={40} />;
}
